import { OBSites } from '../../types';
import { OnboardingSiteAction } from '../../actions/onboarding';
import onboardingUtils from './utils';

export const onboardingSiteReducer = (
  state: OBSites,
  action: OnboardingSiteAction,
): OBSites => {
  switch (action.type) {
    case 'set_sites':
      return onboardingUtils.sitesFromAPI(action.sites);

    case 'set_site':
      return {
        ...state,
        sites: {
          ...state.sites,
          [action.uuid]: action.site,
        },
      };

    default:
      return state;
  }
};
